/* Top bar, from the reference tool. */
.topbar {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  padding: 14px 26px;
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  position: sticky;
  top: 0;
  z-index: 30;
}
.logoLink {
  display: inline-flex;
  align-items: center;
}
.logo {
  display: block;
  height: 31px;
  width: auto;
}
.wordmark {
  font-size: 22px;
  font-weight: 900;
  letter-spacing: -0.03em;
  color: var(--blue-d);
  white-space: nowrap;
}
.wordmark span {
  color: var(--green-l);
}
.toolName {
  font-size: 13px;
  color: var(--muted);
  font-weight: 700;
  padding-left: 18px;
  margin-left: 2px;
  border-left: 1px solid var(--border);
  white-space: nowrap;
}
/* A map's toolbar is full: drop the tool name so it fits on one row at 1366 pixels. */
@media (max-width: 1499px) {
  .withTools .toolName {
    display: none;
  }
}
.spacer {
  flex: 1 1 auto;
}
.who {
  font-size: 13px;
  color: var(--muted);
}
.btn {
  border: 1px solid var(--border-strong);
  background: var(--surface);
  color: var(--blue-d);
  font-weight: 700;
  font-size: 13px;
  padding: 8px 14px;
  border-radius: 9px;
  text-decoration: none;
  display: inline-block;
  transition: all 0.15s ease;
}
.btn:hover {
  border-color: var(--blue-l);
  color: var(--blue-text);
}
.primary {
  background: var(--blue-d);
  border-color: var(--blue-d);
  color: #fff;
  font-size: 15px;
  padding: 11px 20px;
}
.primary:hover {
  background: var(--blue-l);
  border-color: var(--blue-l);
  color: #fff;
}
.inline {
  display: inline;
  margin: 0;
}
.main {
  max-width: 560px;
  margin: 70px auto;
  padding: 0 20px;
}
.card {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 30px 32px;
  box-shadow: var(--shadow);
  text-align: center;
}
.card h1 {
  font-size: 26px;
  margin-bottom: 10px;
}
.card p {
  color: var(--muted);
  margin: 0 0 22px;
}
.eyebrow {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: var(--blue-text);
  margin-bottom: 6px;
}
.alert {
  background: var(--amber-bg);
  border: 1px solid var(--amber-line);
  border-left: 5px solid var(--amber-line);
  border-radius: 11px;
  padding: 12px 15px;
  margin-bottom: 20px;
  text-align: left;
  color: var(--ink);
  font-size: 14.5px;
}

.card p.guestLink {
  margin: 22px 0 0;
  font-size: 14px;
}
